import ENV from '@/config/environment';

export const PRODUCTION_GTM_ID = 'GTM-PT8VSZ';

const Init = () => {
  if(window) {
    window.dataLayer = window.dataLayer || [];

    if(!ENV.gtmId) {
      // Outside production no tag container is loaded (PAE-2465). Say so once, so a captured
      // console shows why nothing reached Google Tag Manager.
      if(ENV.enableQaOutput) {
        // Intentional QA output outside production (PAE-2465).
// eslint-disable-next-line no-console
        console.log(`TB Tracking Output: container ${PRODUCTION_GTM_ID} not loaded (env=${ENV.environment})`);
      }
      return;
    }

    //initialise GTM
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
      });
      var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', ENV.gtmId);
  }
};

export default Init;
